import { __awaiter } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmBack, IconLlmIdea, IconLlmGenerate } from '@websolutespa/bom-mixer-icons';
import { useActions } from '../../../useLlm/useActions.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import style from './page-actions.module.scss.js';

const PageActions = _ref => {
  let {
    wrapper
  } = _ref;
  const label = useLabel();
  const {
    send
  } = useLlmView(state => state.actions);
  const {
    setWrapper
  } = useActions();
  const onAction = action => __awaiter(void 0, void 0, void 0, function* () {
    const prompt = action.message || `${action.label}: ${JSON.stringify(wrapper.actions)}`;
    yield send(prompt, response => {
      // console.log('PageActions.onChunk', response.chunks);
    }, response => {
      // console.log('PageActions.onEnd', response);
    });
  });
  return wrapper.actions.length > 0 && jsxs("div", {
    className: getClassNames(style.actions, '-actions'),
    children: [jsx("button", {
      className: getClassNames(style.back),
      type: "button",
      "aria-label": label('llm.back'),
      onClick: () => setWrapper(null),
      children: jsx(IconLlmBack, {})
    }), wrapper.actions.map(x => jsxs("button", {
      type: "button",
      className: getClassNames(style.action),
      onClick: () => onAction(x),
      children: [jsx(ActionIcon, {
        action: x
      }), jsx("span", {
        children: x.label
      })]
    }, x.id))]
  });
};
function ActionIcon(_ref2) {
  let {
    action
  } = _ref2;
  const icon = action.icon || action.type || 'idea';
  switch (icon) {
    case 'generate':
      return jsx(IconLlmGenerate, {});
    case 'idea':
      return jsx(IconLlmIdea, {});
    default:
      return jsx(IconLlmIdea, {});
  }
}

export { PageActions };
//# sourceMappingURL=page-actions.js.map
